import React, {useState, useEffect, useCallback, useMemo} from "react";
import {connect} from "react-redux"
import {Spinner} from "react-bootstrap";
import moment from "moment";
import NumberFormat from 'react-number-format';
import { motion } from "framer-motion"
import useMediaQuery from "./../../utilities/useMediaQuery"
import {renderIntoDocument} from "react-dom/test-utils";



const InvoicesBaseStyle = {

}


const InvoicesBase = (props)=> {

    const [asData, setAsData] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [invoices, setInvoices] = useState([])


    useEffect(() => {

        fetchInvoices()

    }, [])


    const fetchInvoices = ()=>{

        axios.get('/Api/customer/invoices')
            .then(result=>{
                (result.data)?setInvoices(result.data):null;
                (result.data.length>0)?setAsData(true):null;
                setIsLoading(false)
                //console.log(result.data)
        }).catch(err=>console.log(err))
    }

    const renderItem = (invoice,index)=>{
        return(
            <tr key={index}>
                <td className={""}>{moment.unix(invoice.created).format("MM/DD/YYYY h:m") }</td>
                <td className={"font-weight-bold"}><span style={{"fontFamily":"monospace"}}>{invoice.number}</span></td>
                <td className={""}>{(invoice.billing_reason=='subscription_create')?'Abonnement':'transaction'}</td>
                <td>{(invoice.paid)?<span className={"badge badge-primary badge-pill text-light p-1 fill"}>reglé</span>:<span className={"badge badge-secondary badge-pill text-light"}>En attente de payement</span>}</td>
                <td>
                    <NumberFormat value={(invoice.total*0.01)} displayType={'text'} thousandSeparator={' '} decimalScale={2} suffix={'€'} /> TTC
                 </td>
                <td className={"text-center"}>
                    <a className="btn btn-sm btn-outline-primary m-2"
                       href={invoice.invoice_pdf}>
                    <i className="far fa-file-pdf"></i>
                    </a>

                    <a className="btn btn-sm btn-outline-primary"
                       href={invoice.hosted_invoice_url}>
                        <i className="fas fa-eye"></i>
                    </a>
                </td>
            </tr>
        )
    }

    return (
        <div className={"card ueThemeBackground ueColorBase"}>
            <div className={"card-body"}>
                <div className={"row"}>
                    <div className="col-12 col-lg-8">
                        <h3 className={"card-title my-4 font-weight-light"}><i className="bi bi-receipt text-primary"/> Factures</h3>
                        <table className="table table-fluid  w-100  ueColorBase">
                           <thead className="table-header">
                               <tr>
                                   <th >Date</th>
                                   <th>Numéro</th>
                                   <th >Objet</th>
                                   <th >Statut</th>
                                   <th>Montant</th>
                                   <th> </th>
                               </tr>
                           </thead>

                            {
                                (asData)?
                                <tbody className="table_body">
                                {
                                    (invoices.length>0)?
                                        invoices.map((item,index)=>{
                                            return renderItem(item,index) ;
                                        })
                                        :null
                                }

                                </tbody>
                                : <tbody className="table_body">
                                    {
                                    (isLoading)?
                                        <tr ><td colSpan={6} className={"text-center"}><div className="text-center my-2"><Spinner animation="border" size={'md'}/></div></td></tr>
                                        :<tr ><td colSpan={6} className={"text-center"}><h6><i className="bi bi-exclamation-diamond text-primary"></i><br/>Pas de facture disponible pour votre compte</h6></td></tr>

                                }
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        updateStructureInfo: (e) => dispatch( {type: 'UPDATE_STRUCTURE_INFO', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(InvoicesBase);





